export default function TopDisclaimer() {
  return null;
}
